export default "__VITE_ASSET__DIWlekNE__"